import * as React from 'react';
import type { Message } from '@/types';
import { PublicChatMessage } from './PublicChatMessage';
import type { PublicChatTheme } from '../themes/types';

interface PublicMessageListProps {
  messages: Message[];
  isLoading?: boolean;
  theme: PublicChatTheme;
  onPlayAudio?: (messageId: string) => void;
  onStopAudio?: () => void;
  currentlyPlayingId?: string | null;
  isAudioLoading?: boolean;
}

export const PublicMessageList: React.FC<PublicMessageListProps> = ({
  messages,
  isLoading: _isLoading,
  theme,
  onPlayAudio,
  onStopAudio,
  currentlyPlayingId,
  isAudioLoading,
}) => {
  const bottomRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }, [messages]);

  return (
    <div className='flex min-h-full flex-col justify-end pb-4'>
      {messages.map((message) => (
        <PublicChatMessage
          key={message.id}
          message={message}
          theme={theme}
          onPlayAudio={onPlayAudio}
          onStopAudio={onStopAudio}
          isPlaying={currentlyPlayingId === message.id}
          isAudioLoading={isAudioLoading && !currentlyPlayingId}
        />
      ))}

      {/* Invisible anchor element for auto-scrolling */}
      <div ref={bottomRef} className='h-px w-full' />
    </div>
  );
};
